function initAdMediaSwap() {
  var pending = window.__pendingAdMedia;
  if (!pending) return;

  Object.keys(pending).forEach(function (sectionId) {
    var adMedia = pending[sectionId];
    var productRoot = document.getElementById(sectionId);
    var revealed = false;

    function reveal() {
      if (revealed) return;
      revealed = true;
      document.documentElement.classList.remove('ad-media-pending');
    }

    if (!productRoot || !adMedia || !adMedia.src) {
      reveal();
      return;
    }

    var failsafeTimer = setTimeout(reveal, 2500);

    function tryInsert(attemptsLeft) {
      var cmp = window.Alpine && window.Alpine.$data(productRoot);

      if (cmp && cmp.splide && cmp.splideIsReady) {
        insertAdSlide(cmp);
        return;
      }
      if (attemptsLeft <= 0) {
        reveal();
        return;
      }
      requestAnimationFrame(function () {
        tryInsert(attemptsLeft - 1);
      });
    }

    function insertAdSlide(cmp) {
      var li = document.createElement('li');
      li.className = 'splide__slide bg-scheme-background';
      li.setAttribute('data-index', '0');
      li.setAttribute('data-order', '0');
      li.setAttribute('data-ad-slide', 'true');
      li.innerHTML =
        '<div class="relative w-full" data-product-single-media-wrapper="" data-product-media-type-image="">' +
          '<image-with-placeholder class="relative">' +
            '<img loading="eager" class="peer/image">' +
          '</image-with-placeholder>' +
        '</div>';

      var img = li.querySelector('img');

      function onMove(e) {
        if (e.detail && e.detail.newIndex === 0) {
          cmp.splideEl.removeEventListener('move', onMove);
          clearTimeout(failsafeTimer);
          reveal();
        }
      }

      img.addEventListener('load', function () {
        cmp.splide.Components.Slides.add(li, 0);
        cmp.splideEl.addEventListener('move', onMove);
        cmp.splide.go(0);

        setTimeout(function () {
          cmp.splideEl.removeEventListener('move', onMove);
          reveal();
        }, 400);
      });

      img.addEventListener('error', reveal);
      img.src = adMedia.src;
      img.alt = adMedia.alt || '';
    }

    tryInsert(60);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAdMediaSwap);
} else {
  initAdMediaSwap();
}